<script>
  import { onMount } from "svelte";
  import { csv, json } from "d3-fetch";
  import { feature } from "topojson-client";
  import { geoMercator, geoPath } from "d3-geo";
  import { scaleOrdinal } from "d3-scale";
  import ColorPicker from "./ColorPicker.svelte";
  import Select from "svelte-select";
  import Check from "./check.svelte";

  let gemeentenFeatures = [];
  let natData = [];

  let width;
  let height;
  let path;

  //https://spectrum.adobe.com/page/color-for-data-visualization/
  const colors = /*['#a6cee3','#1f78b4','#b2df8a','#33a02c','#fb9a99','#e31a1c','#fdbf6f','#ff7f00','#cab2d6','#6a3d9a','#ffff99','#b15928']*/[
    "#1EC2C7",
    "#a6cee3",
    "#555555",
    "#cab2d6",
    "#51E76F",
    "#6a3d9a",
    "#DFC10A",
    "#A65A0F",
    "#2D8F6C",
    "#1f78b4",
    "#E7861D",
    "#D81E90"
  ];
  const countries = [
    "Verenigd Koninkrijk","Turkije","Verenigde Staten","Bulgarije","Marokko","Portugal","Duitsland","Polen","Roemenië","Italië","Nederland","Frankrijk"];

  const colorScale = scaleOrdinal().range(colors).domain(countries);
  const reverseColorScale = scaleOrdinal().range(countries).domain(colors);

  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  onMount(() => {
    //csv("data/topnationaliteit.csv").then(function (data) {
      //json("data/gemeenten.json").then(function (gemeenten) {
    csv("data/topnationaliteit20.csv").then(function (data) {
      json("data/belgium-2019-geo.json").then(function (gemeenten) {
        natData = data;
        //gemeentenFeatures = feature(gemeenten, gemeenten.objects.gemeentes)
        //  .features;
        gemeentenFeatures = gemeenten.features;


        const projection = geoMercator().fitExtent(
          [
            [20, 20],
            [width - 40, height - 40],
          ],
          //feature(gemeenten, gemeenten.objects.gemeentes)
          gemeenten
        );
        path = geoPath().projection(projection);
      });
    });
  });
</script>

<svelte:head>
  <link
    href="https://fonts.googleapis.com/css?family=PT+Sans"
    rel="stylesheet"
  />
</svelte:head>

<div class="title">
  <h2>
    Raad de legende: vind jij de talrijkste buitenlandse nationaliteit in elke
    gemeente?
  </h2>
  <p>
    Klik op de rechthoekjes in de legende om een kleur te selecteren, raak een
    gemeente aan om ze te identificeren
  </p>
</div>
<div class="content">
  <div class="colorpickers">
    {#each shuffleArray(countries) as country, i}
      <ColorPicker {country} {colors} revColScale={reverseColorScale} /><br />
    {/each}
    <div class="picker">
      <div class="icon-container check">
        <Check />
      </div>
      <div class="select-container">
        <Select
          isDisabled={true}
          isSearchable={false}
          showIndicator={false}
          isClearable={false}
          inputStyles={`background-color: #cccccc; border: none; cursor: pointer;`}
        />
      </div>
      <div class="country-name">Andere nationaliteiten</div>
    </div>
  </div>
  <div class="chart" bind:clientWidth={width} bind:clientHeight={height}>
    <svg {width} {height}>
      {#each gemeentenFeatures as feat, i}
        <path
          d={path(feat)}
          fill={countries.includes(
            natData.filter((d) => +d.NIS == +feat.properties.NISCODE_2019)[0].Nationaliteit
          )
            ? colorScale(
                natData.filter((d) => +d.NIS == +feat.properties.NISCODE_2019)[0].Nationaliteit
              )
            : "#cccccc"}
          stroke={"#ffffff"}
          stroke-width={1}
          ><title>{natData.filter((d) => +d.NIS == +feat.properties.NISCODE_2019)[0].Gemeente}</title
          ></path
        >
      {/each}
    </svg>
  </div>
</div>

<style>
  :global(body) {
    font-family: "PT Sans";
  }
  .content {
    display: flex;
    max-width: 960px;
  }
  .chart {
    flex: 1;
    height: 550px;
  }

  svg {
    overflow: visible;
  }
  .colorpickers {
    width: 240px;
    order: 2;
  }
</style>
